import { ENV_DEV } from "../../../utils/window";
import setBounds from "../../store/utils/set-bounds";

/**
 * Add attribute
 * @param {Array<HTMLElement>} targets
 * @param {String} _name
 * @param {String} _values
 * @param {PropertyValueProps} property
 */
const boundsGet = (targets, _name, _values, property) => {
  if (ENV_DEV && targets.length > 1) {
    console.error(
      `[TorusKit warn]: More than one element targeted in the \`${property.get(
        "action-original"
      )}\``
    );

    return;
  }

  const target = /** @type {TorusElement} */ (targets[0]);

  /** @type {BoundsProps | null} */
  const bounds =
    target["tor-bounds"] || setBounds(target, null, null, target, true);

  if (!bounds) {
    return;
  }

  /** Bounds type (height, width) */
  const type = /** @type {keyof BoundsObjectProps} */ (
    property.get("action-property")
  );

  return `${bounds.get(type)}px`;
};

export default boundsGet;
